"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hexToRgb;

function hexToRgb(hex) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return null;
  return result.slice(1, 4).map(function (item) {
    return parseInt(item, 16);
  }).join(', ');
}